import React, { useEffect, useState } from 'react';
import 'react-responsive-modal/styles.css';
import { MdClose } from 'react-icons/md';
import PropTypes from 'prop-types';
import { IoIosArrowForward } from 'react-icons/io';
import YouTube from 'react-youtube';

import leadershipSchool from '../../data/leadershipSchool';
import leadershipSchoolVideos from '../../data/leadershipSchoolVideos';

import bitSchool from '../../data/bitSchool';
import smeSchool from '../../data/smeSchool';
import cultureSchool from '../../data/cultureSchool';
import bankingSchool from '../../data/bankingSchool';
import businessSchool from '../../data/businessSchool';

function SchoolsGallery({ selectedtab }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [dataImage, setDataImage] = useState([]);

  const handleImgClick = (item) => {
    setSelectedImg(item);
    setShowModal(true);
  };

  useEffect(() => {
    switch (selectedtab) {
    case 'BIT School':
      setDataImage(bitSchool);
      break;
    case 'Culture School':
      setDataImage(cultureSchool);
      break;
    case 'Banking School':
      setDataImage(bankingSchool);
      break;
    case 'Business School':
      setDataImage(businessSchool);
      break;
    case 'Leadership School':
      setDataImage(leadershipSchool);
      break;
    case 'SME School':
      setDataImage(smeSchool);
      break;
    default:
      setDataImage(bitSchool);
      break;
    }
  }, [selectedtab]);

  return (
    <div className="w-full mt-20">
      <div>
        <div className="flex flex-wrap -mx-4 sm:-mx-5">
          {dataImage?.map((item) => (
            <div key={item?.sn} className="w-full p-4 sm:p-5 sm:w-1/2 lg:w-1/3">
              <button onClick={() => handleImgClick(item)} type="button" aria-label="View image">
                <img src={item?.img} className="rounded-lg" alt="" />
              </button>
            </div>
          ))}
        </div>

        {selectedtab === 'Leadership School' && (
          <div className="w-full mt-36">
            <div className="flex flex-wrap -mx-4 sm:-mx-5">
              {leadershipSchoolVideos?.map((item) => (
                <div key={item?.id} className="w-full p-4 sm:p-5 sm:w-1/2 lg:w-1/3">
                  <div>
                    <YouTube
                      videoId={item?.video_id}
                      iframeClassName="w-full h-60 rounded-lg"
                    />
                    <h3 className="text-lg font-semibold mt-3 mb-2">{item?.title}</h3>
                    <p className="text-primary">{item?.subTitle}</p>
                    <p className="my-5 text-sm">{item?.summary}</p>
                    <a href={item?.link} target="_blank" rel="noreferrer">
                      <p className="text-sm font-bold flex items-end text-primary underline underline-offset-2">
                        View on YouTube
                        <IoIosArrowForward />
                      </p>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {showModal && selectedImg ? (
          <div className="justify-center flex fixed inset-0 z-50 bg-black/60">
            <div className="relative w-full md:w-2/3 p-4 m-auto">
              <MdClose className="absolute top-6 right-6 z-10 h-6 w-6 cursor-pointer" onClick={() => setShowModal(false)} />
              <img src={selectedImg.img} className="w-full" alt="" />
            </div>
          </div>
        ) : null}

      </div>
    </div>
  );
}

SchoolsGallery.propTypes = {
  selectedtab: PropTypes.string
};

SchoolsGallery.defaultProps = {
  selectedtab: ''
};

export default SchoolsGallery;
